var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9583 32.0834C18.1595 32.0834 17.4999 32.7429 17.4999 33.5417V59.7917C17.4999 60.5904 18.1595 61.25 18.9583 61.25H51.0416C51.8403 61.25 52.4999 60.5904 52.4999 59.7917V33.5417C52.4999 32.7429 51.8403 32.0834 51.0416 32.0834H18.9583ZM14.5833 33.5417C14.5833 31.1321 16.5487 29.1667 18.9583 29.1667H51.0416C53.4512 29.1667 55.4166 31.1321 55.4166 33.5417V59.7917C55.4166 62.2013 53.4512 64.1667 51.0416 64.1667H18.9583C16.5487 64.1667 14.5833 62.2013 14.5833 59.7917V33.5417Z",
    fill: "#0A435B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0001 8.74998C28.5021 8.74998 23.3334 13.7653 23.3334 19.775V30.625C23.3334 31.4304 22.6805 32.0833 21.8751 32.0833C21.0697 32.0833 20.4167 31.4304 20.4167 30.625V19.775C20.4167 12.0179 27.0314 5.83331 35.0001 5.83331C42.9375 5.83331 49.5834 12.0159 49.5834 19.775V30.625C49.5834 31.4304 48.9305 32.0833 48.1251 32.0833C47.3197 32.0833 46.6667 31.4304 46.6667 30.625V19.775C46.6667 13.7674 41.471 8.74998 35.0001 8.74998Z",
    fill: "#0A435B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0001 43.75C33.3893 43.75 32.0834 45.0558 32.0834 46.6666C32.0834 48.2775 33.3893 49.5833 35.0001 49.5833C36.6109 49.5833 37.9167 48.2775 37.9167 46.6666C37.9167 45.0558 36.6109 43.75 35.0001 43.75ZM29.1667 46.6666C29.1667 43.445 31.7784 40.8333 35.0001 40.8333C38.2217 40.8333 40.8334 43.445 40.8334 46.6666C40.8334 49.8883 38.2217 52.5 35.0001 52.5C31.7784 52.5 29.1667 49.8883 29.1667 46.6666Z",
    fill: "#0A435B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.aa7f5c26fc8e5ddda0fd53a22605357d.svg";
export { ForwardRef as ReactComponent };